import { MessagesResource } from 'affiny-core/modules/api/core/resources/messages.resource';
import {
  IApiMessage,
  messageSerializer,
} from 'affiny-core/modules/api/models/message';
import { selectAccountId } from 'affiny-core/redux/selectors/accountSelectors';
import { call, select } from 'redux-saga/effects';
import { EAffinyEventOrigin } from '../../core/affiny.eventorigins';
import { messagesNormalizer } from './messages.normalizer';

export const PAGE_SIZE = 20;

export function* getMessages(
  otherAccountId: string,
  pageNumber: number,
  pageSize: number = PAGE_SIZE
) {
  const myAccountId: string = yield select(selectAccountId);

  const messagesResponse: IApiMessage = yield call(
    MessagesResource.getMessages,
    `${myAccountId}_${otherAccountId}`,
    pageNumber,
    pageSize
  );

  return messagesNormalizer(messagesResponse);
}

export function* postMessage({
  senderAboId,
  receiverAboId,
  content,
  eventOrigin,
}: {
  senderAboId: string;
  receiverAboId: string;
  content: string;
  eventOrigin: EAffinyEventOrigin;
}) {
  const DRY_RUN = false;
  const message = yield call(
    MessagesResource.postMessage,
    senderAboId,
    receiverAboId,
    DRY_RUN,
    content,
    eventOrigin
  );

  return messageSerializer(message);
}
